document.addEventListener('DOMContentLoaded', () => {
  const cartItems = document.querySelector('#main-cart-items');

  if (!cartItems) return;

  let isUpdating = false;

  async function updateCart(line, quantity) {
    if (isUpdating) return;

    isUpdating = true;
    document.documentElement.style.cursor = 'wait';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity),
        }),
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      window.location.reload();
    } catch (error) {
      console.error(error);
      alert('Varukorgen kunde inte uppdateras. Försök igen.');
      isUpdating = false;
      document.documentElement.style.cursor = '';
    }
  }

  cartItems.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('.quantity__button');

    if (quantityButton) {
      event.preventDefault();

      const wrapper = quantityButton.closest('.cart-item__quantity-wrapper');
      const input = wrapper?.querySelector('.quantity__input');

      if (!input) return;

      const current = Number(input.value) || 1;
      const step = Number(input.step) || 1;
      const minimum = Number(input.min) || 0;
      const maximum = input.max ? Number(input.max) : Infinity;

      let newQuantity = current;

      if (quantityButton.name === 'plus') {
        newQuantity = Math.min(current + step, maximum);
      }

      if (quantityButton.name === 'minus') {
        newQuantity = Math.max(current - step, minimum);
      }

      updateCart(input.dataset.index, newQuantity);
      return;
    }

    const removeButton = event.target.closest('cart-remove-button a');

    if (removeButton) {
      event.preventDefault();

      const container = removeButton.closest('cart-remove-button');
      updateCart(container.dataset.index, 0);
    }
  });

  cartItems.addEventListener('change', (event) => {
    const input = event.target.closest('.quantity__input');

    if (!input) return;

    const minimum = Number(input.min) || 0;
    const maximum = input.max ? Number(input.max) : Infinity;
    const quantity = Math.min(
      Math.max(Number(input.value) || minimum, minimum),
      maximum
    );

    updateCart(input.dataset.index, quantity);
  });
});